import { render, staticRenderFns } from "./LicitacaoId.vue?vue&type=template&id=18aeeb3c&scoped=true&"
import script from "./licitacaoId.ts?vue&type=script&lang=ts&"
export * from "./licitacaoId.ts?vue&type=script&lang=ts&"
import style0 from "./LicitacaoId.vue?vue&type=style&index=0&id=18aeeb3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aeeb3c",
  null
  
)

export default component.exports